export const PRODUCT_BOOST_LIST_SUCCESS = 'PRODUCT_BOOST_LIST_SUCCESS';
export const CREATE_PRODUCT_BOOST_SUCCESS = 'CREATE_PRODUCT_BOOST_SUCCESS';
export const REMOVE_PRODUCT_BOOST_SUCCESS = 'REMOVE_PRODUCT_BOOST_SUCCESS';
